import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';

export const useIsJsmOnly = (): boolean => {
	const { hasServiceDeskAccess, hasCustomerServiceAccess } = useApplicationPermissions();

	return hasServiceDeskAccess && !hasCustomerServiceAccess;
};
